import { createPromiseAction } from '@adobe/redux-saga-promise';

import * as actionTypes from './actionTypes';

export const getUserDetails = createPromiseAction(actionTypes.GET_USER_DETAILS);
export const setDefaultTab = createPromiseAction(actionTypes.SET_DEFAULT_TAB);
export const toggleSoundNotifications = createPromiseAction(actionTypes.TOGGLE_SOUND_NOTIFICATIONS);
